///////COMPONENTS///////
import { put, select, takeLatest, fork, take, cancel, delay, cancelled } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, notificationsActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getLogsNotification = function* ({ payload }) {
	// Starts the task in background
	const bgSyncTask = yield fork(getLogsNotificationLongPolling)

	// Wait for the user stop action
	yield take(ActionsTypes.CLOSE_NOTIFICATIONS_POLLING)

	// User clicked stop. cancel the background task
	// This will cause the forked bgSync task to jump into its finally block
	yield cancel(bgSyncTask)
}

const getLogsNotificationLongPolling = function* () {
	const user = yield select(selectIdsUser)
	let count = 0

	try {
		while (true) {
			let data
			if (count) {
				data = yield delay(50000, API_TOKEN(user.jwt).get(R.GET_LOGS_NOTIFICATION()))
			} else {
				data = yield API_TOKEN(user.jwt).get(R.GET_LOGS_NOTIFICATION())
			}
			yield put(notificationsActionCreators.getLogsNotificationSuccess(data.data))
			count++
		}
	} catch (e) {
		yield put(notificationsActionCreators.getLogsNotificationFailure(e.response))
	} finally {
		if (yield cancelled()) yield put(notificationsActionCreators.getLogsNotificationFailure('STOP'))
	}
}

const updateResolvedLog = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.UPDATE_RESOLVED_LOG(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(notificationsActionCreators.closeNotificationsPolling())
		yield put(notificationsActionCreators.getLogsNotification())

		yield put(notificationsActionCreators.updateResolvedLogSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__notif_resolved'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(notificationsActionCreators.updateResolvedLogFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const closeNotification = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CLOSE_NOTIFICATION(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(notificationsActionCreators.closeNotificationsPolling())
		yield put(notificationsActionCreators.getLogsNotification())

		yield put(notificationsActionCreators.closeNotificationSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__notif_proceed'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(notificationsActionCreators.closeNotificationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const closeAllNotification = function* ({ payload }) {
	const bodyMsg = payload.ids
	const user = yield select(selectIdsUser)
	const apiCall = R.CLOSE_ALL_NOTIFICATION()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMsg)

		yield put(notificationsActionCreators.closeNotificationsPolling())
		yield put(notificationsActionCreators.getLogsNotification())

		yield put(notificationsActionCreators.closeAllNotificationSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__notif_closed'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(notificationsActionCreators.closeAllNotificationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const reportNotification = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.REPORT_NOTIFICATION(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(notificationsActionCreators.closeNotificationsPolling())
		yield put(notificationsActionCreators.getLogsNotification())

		yield put(notificationsActionCreators.reportNotificationSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__notif_reported'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(notificationsActionCreators.reportNotificationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_LOGS_NOTIFICATION, getLogsNotification)
	yield takeLatest(ActionsTypes.UPDATE_RESOLVED_LOG, updateResolvedLog)
	yield takeLatest(ActionsTypes.CLOSE_NOTIFICATION, closeNotification)
	yield takeLatest(ActionsTypes.CLOSE_ALL_NOTIFICATION, closeAllNotification)
	yield takeLatest(ActionsTypes.REPORT_NOTIFICATION, reportNotification)
}

export default sagas
